<h3>Ficha de proveedor</h3>

@if (isLoadingDetail && !detail) {
  <div class="flex flex-col gap-4">
    <div class="flex flex-row gap-4 h-full">
      <div class="aspect-square h-[6.6rem] rounded-full skeleton skeleton-rect shrink-0"></div>
      <div class="flex flex-col gap-2 w-full">
        <div class="h-6 w-1/3 skeleton skeleton-rect rounded-md"></div>
        <div class="h-4 w-1/4 skeleton skeleton-rect rounded-md"></div>
        <div class="h-4 w-1/5 skeleton skeleton-rect rounded-md"></div>
        <div class="flex flex-row flex-wrap gap-2 mr-auto">
          <div class="h-6 w-24 skeleton skeleton-rect rounded-full"></div>
          <div class="h-6 w-20 skeleton skeleton-rect rounded-full"></div>
          <div class="h-6 w-32 skeleton skeleton-rect rounded-full"></div>
        </div>
      </div>
      <div class="h-10 w-32 skeleton skeleton-rect rounded-xl ml-auto mb-auto"></div>
    </div>

    <div class="flex gap-2 flex-row flex-wrap">
      <div class="h-8 w-40 skeleton skeleton-rect rounded-full"></div>
      <div class="h-8 w-36 skeleton skeleton-rect rounded-full"></div>
      <div class="h-8 w-44 skeleton skeleton-rect rounded-full"></div>
    </div>
  </div>
} @else {
<div class="flex flex-row gap-4 h-full">

  <div class="btn btn-neutral-outline avatar !w-[6.6rem] !h-[6.6rem] overflow-hidden shrink-0">
    @if (isLoadingLogo) {
      <div class="h-full w-full skeleton skeleton-rect rounded-full"></div>
    } @else if (logoSrc()) {
      <img [src]="logoSrc()" alt="Logo" class="h-full w-full object-cover rounded-full block" (error)="handleLogoError($event)"/>
    }
  </div>

  <div class="flex flex-col gap-1 w-full">
    <h6 class="pb-1">{{ detail?.name || supplier?.name || 'Proveedor' }}</h6>
    <span class="cd-text-b3 text-neutral-600">{{ detail?.contact || supplier?.contact || 'Sin contacto' }}</span>
    <span class="cd-text-b3 text-neutral-600">{{ detail?.taxId || supplier?.taxId || '-' }}</span>
    <div class="flex flex-row flex-wrap gap-2 mr-auto">
      <span class="cd-text-b3 text-neutral-600">{{ notes.length }} Notas</span>
      <span class="cd-text-b3 text-neutral-600">{{ attachments.length }} Archivos adjuntos</span>
    </div>
  </div>

  <button (click)="edit.emit()"
          class="btn btn-primary flex flex-row gap-2 items-center min-w-[8rem] ml-auto mb-auto">
    <span class="lg:block cd-text-md truncate capitalize">Editar datos</span>
  </button>

</div>

<div class="flex gap-2 flex-row flex-wrap">

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/user.svg">
    <span class="truncate">{{ detail?.website || supplier?.website || '-' }}</span>
  </div>

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/phone.svg">
    <span class="truncate">{{ detail?.phone || supplier?.phone || '-' }}</span>
  </div>

  <div class="outline primary truncate !py-1 !px-2 cd-text-b4 text-center flex flex-row gap-2">
    <img alt="Icon" class="filter-primary-600 h-4" src="/assets/icons/feather/mail.svg">
    <span class="truncate">{{ detail?.email || supplier?.email || '-' }}</span>
  </div>

</div>
}

@if (detailError && !isLoadingDetail) {
  <span class="cd-text-b4 text-error-600">{{ detailError }}</span>
}

<core-tabs [config]="[
    { slug: 'attachments', label: 'Documentación', template: attachmentsTabTpl},
    { slug: 'notes', label: 'Notas', template: notesTabTpl}
  ]"/>

<ng-template #attachmentsTabTpl let-slug>
  @if (isLoadingAttachments) {
    <span class="cd-text-b4 text-neutral-500">Cargando adjuntos...</span>
  } @else if (attachmentsError) {
    <span class="cd-text-b4 text-error-600">{{ attachmentsError }}</span>
  } @else if (documentationAttachments.length) {
    <div class="flex flex-col gap-2">
      @for (file of documentationAttachments; track file.id) {
        <core-file-widget
          [fileName]="file.fileName"
          [fileSize]="formatFileSize(file.fileSize)"
          [showRemove]="false"
          (download)="downloadAttachment(file)"/>
      }
    </div>
  } @else {
    <span class="cd-text-b4 text-neutral-500">Sin documentos adjuntos.</span>
  }
</ng-template>

<ng-template #notesTabTpl let-slug>
  <div class="group-file-tab-shell">
    <div class="flex flex-col gap-3">
      <div class="bg-white rounded-xl p-2.5 shadow-e1 flex flex-col gap-2.5">
        <textarea
          [(ngModel)]="noteDraft"
          [disabled]="isSubmittingNote"
          class="group-file-note-input"
          id="supplier-note"
          placeholder="Escribe una nota útil para el seguimiento del proveedor"></textarea>
        <div class="flex items-center justify-end gap-3">
          @if (notesError && !isSubmittingNote) {
            <span class="cd-text-b5 text-error-600">{{ notesError }}</span>
          }
          <button class="btn btn-primary" type="button" [disabled]="isSubmittingNote || !noteDraft.trim()" (click)="submitNote()">
            {{ isSubmittingNote ? 'Guardando...' : 'Agregar nota' }}
          </button>
        </div>
      </div>

      @if (isLoadingNotes || isRefreshingNotes) {
        @for (item of tabSkeletonItems; track item) {
          <div class="flex flex-col gap-2 bg-white rounded-xl p-2.5 shadow-e1">
            <div class="h-4 w-40 skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-full skeleton skeleton-rect rounded-md"></div>
            <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
          </div>
        }
      } @else if (notes.length) {
        <div class="flex flex-col gap-2">
          @for (note of notes; track note.id) {
            <div
              [class.opacity-60]="isDeletingNote(note.id)"
              class="flex flex-col gap-1 bg-white rounded-xl p-2.5 shadow-e1">
              <div class="flex items-start gap-3">
                @if (isDeletingNote(note.id)) {
                  <div class="h-4 w-40 skeleton skeleton-rect rounded-md"></div>
                } @else {
                  <span class="cd-text-b3 font-medium">{{ authorName(note) }}</span>
                }
                <button class="btn btn-neutral-text !px-1 !py-1 ml-auto" type="button" [disabled]="isDeletingNote(note.id)" (click)="deleteNote(note.id)">
                  <img alt="Eliminar" class="h-4 filter-neutral-800" src="/assets/icons/feather/trash-2.svg">
                </button>
              </div>
              @if (isDeletingNote(note.id)) {
                <div class="h-3 w-full skeleton skeleton-rect rounded-md"></div>
                <div class="h-3 w-24 skeleton skeleton-rect rounded-md"></div>
              } @else {
                <span class="cd-text-b4 text-neutral-700 whitespace-pre-line">{{ note.content }}</span>
                <span class="cd-text-b5 text-neutral-500">{{ formatDate(note.createdAt) }}</span>
              }
            </div>
          }
        </div>
      } @else {
        <span class="cd-text-b4 text-neutral-500">Sin notas registradas.</span>
      }
    </div>
  </div>
</ng-template>
